import { format } from "date-fns";
import { showDeliveryState } from "../components/common/styles/order-states.style";
import { DeliveryState } from "../enums/orders";
import { ChangeLog, OrderEvent } from "../interfaces/delivery-company/orders";

const isEmpty = (val: string | null) => {
    return val == null || val.length == 0
}
const parseFieldChangeLog = (field: string, changeLog: ChangeLog): React.ReactNode => {

    const formatted_field = field.replaceAll("_", " ")

    if (["order_id", "reference_id", "description", "workflow", "customer_location", "merchant_location", "price", "delivery_fee", "driver_commission", "number_of_packages", "private_note", "public_note", "description", "shelf", ].includes(field)) {
        if (isEmpty(changeLog.new) && !isEmpty(changeLog.old)) {
            return `removed ${formatted_field} (previous value was ${changeLog.old})`
        }

        if (!isEmpty(changeLog.new) && isEmpty(changeLog.old)) {
            return `set ${formatted_field} to ${changeLog.new}`
        }

        if (isEmpty(changeLog.new) && isEmpty(changeLog.old)) return null

        return `changed ${formatted_field} from ${changeLog.old} to ${changeLog.new}`
    }

    if (field == "frozen_until") {
        if (changeLog.new == "None") {
            return "order unfrozen"
        }

        return `order frozen until ${format(changeLog.new!, "dd-MM-yyyy")}`
    }

    if (field == "delivery_state") {
        return <>changed delivery state from {changeLog.old} to {changeLog.new}</>
    }

    if (field == "is_critical") {
        const old_val = JSON.parse(changeLog.old ?? "false")
        const new_val = JSON.parse(changeLog.new ?? "false")
        if (old_val == new_val) return "";

        if (new_val) {
            return `marked order as critical`
        }
        else return `marked order as not critical`
    }

    if (field == "merchant_invoice") {
        if (changeLog.old == "0") {
            return "Created merchant invoice"
        } else {
            return "Removed order from merchant invoice"
        }
    }

    if (field == "driver_invoice") {
        if (changeLog.old == "0") {
            return "Created driver invoice"
        } else {
            return "Removed order from driver invoice"
        }
    }

    if (field == "last_pickup_task") {
        if (changeLog.old == null) {
            return "Scheduled for pickup"
        } else {
            return "Removed from pickup task"
        }
    }

    if (field == "last_delivery_task") {
        if (changeLog.old == "0") {
            return "Scheduled for delivery"
        } else {
            return "Removed order from delivery batch"
        }
    }

    return ""
}

export const parseOrderEventActor = (event: OrderEvent): string => {
    return `${event.actor_snapshot.role}: ${event.actor_snapshot.name} ${event.actor_snapshot.phone_number}`
}

export const parseOrderEventChanges = (event: OrderEvent) => {
    const changes: React.ReactNode[] = []
    for (const [key, value] of Object.entries(event.changes)) {
        const log = parseFieldChangeLog(key, value)
        if (log) {
            changes.push(log)
        }
    }
    return changes
}